<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brandBasilur" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/greenIsland/green_island.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/greenIsland/green_island.svg" alt="" />
      <router-link to="/brands" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/greenIsland/p1.png'),
          require('../../assets/img/brands/greenIsland/p2.png'),
          require('../../assets/img/brands/greenIsland/p3.png'),
          require('../../assets/img/brands/greenIsland/p4.png'),
          require('../../assets/img/brands/greenIsland/p5.png'),
          require('../../assets/img/brands/greenIsland/p6.png'),
          require('../../assets/img/brands/greenIsland/p7.png'),
          require('../../assets/img/brands/greenIsland/p8.png'),
          require('../../assets/img/brands/greenIsland/p9.png'),
          require('../../assets/img/brands/greenIsland/p10.png'),
          
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <p>{{ $t('brands.greenIsland.desc') }}</p>
          <br />
          <p class="continets__text">{{ $t('brands.greenIsland.desc2') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/world.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>

<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';
.container__brand {
  background: #197a3a 0% 0% no-repeat padding-box;
}
</style>